var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page wap"},[_c('Header'),_c('Banner'),_c('Carousel',{attrs:{"isSelf":true}}),_c('div',{staticClass:"m-wap-page page-bottom"},[_c('List')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }